import _ from 'lodash';
import Vue from 'vue';


export function dispatchesQueries(default_query) 
{
	return {
		setQuery: function(context, params) 
		{
			context.commit('handleSetQuery', params);
		},

		setQueryParam: function(context, payload) 
		{
			context.commit('handleSetQueryParam', payload);
		},

		resetQuery: function(context, params) 
		{
			context.commit('handleSetQuery', default_query);
		},
	}
	
}

export function mutatesQueries() 
{
	return {
		handleSetQuery: function (state, payload) {
			_.set(state, 'query', payload);
		},

		handleSetQueryParam: function (state, payload) {
			_.each(payload, (value, key) => {
				if (value != null) {
					_.set(state.query, key, value);
				} else {
					_.unset(state.query, key);
				}
			});
			state.query = Object.assign({}, state.query);
		},
	}
}



export function dispatchesSchema() 
{
	// nothing to do here...
}


export function mutatesSchema() 
{
	return {
		handleSchemaLoaded: function (state, data) {
			_.set(state, `schema`, data);
		},

		handleInititalizingInstanceFromSchema: function (state, payload) {
			let new_insance = {};
			_.each(payload, (config,k) => {
				let key = config.id;
				let default_value 	= _.get(config, 'default', null);
				let current_value 	= _.get(config, 'value', default_value);
				current_value 		= current_value != null ? current_value : default_value; 
				// if (key == 'room_size') console.log(current_value)
				_.set(new_insance, key, current_value);
			});
			state.instance = new_insance;
		}
	}
}



export function updatePagination(state, uuid, callback) {

	let items = _.get(state, 'pagination.data');
	let index = _.findIndex(items, e => e.uuid == uuid);
	if (index >= 0) {
		let item = Object.assign({}, items[index]);
		let result = callback(item);
		if (result) {
			items = items.splice(index, 1, result); 
		} else {
			items = items.splice(index, 1);
		}
		Vue.$set(state.pagination, 'data', items);
	}
}





export function resetsState(initial_state) {
	let _initial_state = Object.assign({}, initial_state);
	return {
		handleResetState: function(state) {
			state = _initial_state;
		}
	}
}